import { nanoid } from "@reduxjs/toolkit";

export const createChartDataState = () => ({
  data: {},
  isLoading: false,
  pendingRequests: 0,
  error: null,
  success: false,
});

export const EMPTY_CHART_STATE = Object.freeze(createChartDataState());

export const selectChartScope = (slice, scope) =>
  (scope ? slice?.scopes?.[scope] : slice) || EMPTY_CHART_STATE;

export const prepareChartRequest = (payload) => ({
  payload: payload?.scope
    ? { ...payload, requestId: payload.requestId || nanoid() }
    : payload,
});

const updateRequestState = (target) => {
  target.pendingRequests = Object.keys(target.requests).length;
  target.isLoading = target.pendingRequests > 0;
  target.error = Object.values(target.errors)[0] || null;
};

export const startScopedRequest = (state, payload, key) => {
  if (!payload?.scope) return false;
  state.scopes ||= {};
  const target = state.scopes[payload.scope] ||= {
    ...createChartDataState(), requests: {}, errors: {},
  };
  target.requests[key] = payload.requestId;
  delete target.errors[key];
  target.success = false;
  updateRequestState(target);
  return true;
};

export const finishScopedRequest = (state, payload, key, failed = false) => {
  if (!payload?.scope) return false;
  const target = state.scopes?.[payload.scope];
  if (!target || !payload.requestId || target.requests[key] !== payload.requestId) return true;
  delete target.requests[key];
  if (failed) {
    target.errors[key] = payload.error;
  } else {
    target.data[key] = payload.data;
    delete target.errors[key];
  }
  target.success = !failed;
  updateRequestState(target);
  return true;
};

export const removeScopedSeries = (state, payload, key) => {
  if (!payload?.scope) return false;
  const target = state.scopes?.[payload.scope];
  if (target) {
    delete target.data[key];
    delete target.requests[key];
    delete target.errors[key];
    updateRequestState(target);
  }
  return true;
};

export const resetChartScope = (state, payload) => {
  if (payload?.scope) {
    delete state.scopes?.[payload.scope];
  } else {
    Object.assign(state, createChartDataState());
  }
};
